import { KeyValueModel } from "model/api";
import { EnumIndEscala } from "../../model/enums/enum-ind-escala";

export const IndEscalaMock: KeyValueModel[] = [
  new KeyValueModel(EnumIndEscala.S, "Produzido em Escala Relevante"),
  new KeyValueModel(EnumIndEscala.N, "Produzido em Escala Não Relevante"),
];
